import { DateInput } from "@blueprintjs/datetime";
import { IWidgetProps } from "decorator-form";
import React from "react";

import { registerWidget } from "common/form/register";

interface IDatePickerWidgetSettings {
	minDate?: Date;
	maxDate?: Date;
}

interface IDatePickerWidgetProps extends IWidgetProps<string> {
	settings?: IDatePickerWidgetSettings;
	minDate?: Date;
	maxDate?: Date;
}


export class DatePickerWidget extends React.PureComponent<IDatePickerWidgetProps> {

	public static registerWithSettings(settings: IDatePickerWidgetSettings) {
		return registerWidget(
			(props: IDatePickerWidgetProps) => <DatePickerWidget {...props} settings={settings} />,
			"date"
		);
	}

	public render() {
		const { settings = {} , value } = this.props;
		const dt = new Date(value);
		
		return (
			<DateInput
				onChange={this.handleChange}
				formatDate={(dv) => dv.toLocaleDateString()}
				value={dt instanceof Date && !isNaN(dt as any) ? dt : undefined}
				maxDate = {this.props.maxDate || undefined}
				minDate = {this.props.minDate || undefined}
			/>
		);
	}

	private handleChange = (dt: Date) => {
		this.props.onChange(dt.toISOString());
	}
}

export const datePickerInput = DatePickerWidget.registerWithSettings({});



// WEBPACK FOOTER //
// ./src/common/form/widgets/date/DatePickerWidget.tsx